import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { requestSelfEmploymentProfile } from '../actions'
import { getSelfEmploymentProfile } from '../selectors/self-employment-profile'

export const useSelfEmploymentProfile = () => {
    const dispatch = useDispatch()

    const profile = useSelector(getSelfEmploymentProfile)
    const { shouldFetch } = profile

    useEffect(() => {
        if (!shouldFetch) return
        dispatch(requestSelfEmploymentProfile())
    }, [dispatch, shouldFetch])

    return profile
}
